// A Stripe confirm*Payment error in the standard error shape (src/utils/userError.js).
// Money first: anything that is not a clear decline or a detail to fix may have charged the
// customer, so it is PAYMENT-UNKNOWN-STATE and never invites a retry.
import { ERROR_CODES, knownError, userError } from './userError';

const DECLINE_GUIDANCE = 'Try another card or payment method.';

export function stripePaymentError(stripeError) {
  const error = stripeError || {};
  const serverId = (error.payment_intent && error.payment_intent.id) || undefined;
  // Stripe writes card_error and validation_error messages for customers ("Your card has
  // insufficient funds."): they are the reason, so they are the body.
  const reason = typeof error.message === 'string' ? error.message.trim() : '';

  if (error.code === 'expired_card') {
    return knownError(ERROR_CODES.PAYMENT_CARD_EXPIRED, {
      title: 'Your card has expired',
      message: 'This card can no longer be used.',
      guidance: DECLINE_GUIDANCE,
      serverId,
    });
  }
  if (error.code === 'payment_intent_authentication_failure') {
    return knownError(ERROR_CODES.PAYMENT_3DS_FAILED, {
      title: "Your bank didn't confirm the payment",
      message: "The bank's security check was not completed, so you were not charged.",
      guidance: "Try again and complete your bank's check, or use another card.",
      serverId,
    });
  }
  if (error.type === 'card_error') {
    return knownError(ERROR_CODES.PAYMENT_DECLINED, {
      title: 'Your card was declined',
      message: reason,
      guidance: DECLINE_GUIDANCE,
      serverId,
    });
  }
  if (error.type === 'validation_error') {
    return knownError(ERROR_CODES.PAYMENT_DETAILS_INVALID, {
      title: 'Check your payment details',
      message: reason,
      guidance: 'Correct the details, then pay again.',
      serverId,
    });
  }
  return userError(null, { area: 'PAYMENT', paymentUnknown: true, serverId });
}

/** A payment detail the form checked itself (a missing or too long name). */
export function paymentDetailsError(title, guidance) {
  return knownError(ERROR_CODES.PAYMENT_DETAILS_INVALID, { title, guidance });
}



// WEBPACK FOOTER //
// ./src/utils/stripeError.js